import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
  }

  endOfWeek(event) {
    event.preventDefault()
    const date = new Date()
    const day = date.getDay()
    const diff = date.getDate() + (7 - day)
    date.setDate(diff)
    this.inputTarget.value = this.formatDate(date)
  }

  // TODO: Fix it. this show the last day of the previous month. I want it to show day 1!
  beginningOfMonth(event) {
    event.preventDefault()
    const date = new Date()
    date.setMonth(date.getMonth())
    date.setDate(1)
    this.inputTarget.value = this.formatDate(date)
  }
  
  endOfMonth(event) {
    event.preventDefault()
    const date = new Date()
    date.setMonth(date.getMonth() + 1)
    date.setDate(0)
    this.inputTarget.value = this.formatDate(date)
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}
